
import ApiActions from '../../actions/api';
import Constants from './constants';
import Store from './store';

class Actions {

  static fetchAccount() {

    ApiActions.get(
      '/v1/users/my',
      undefined,
      Store,
      Constants.FETCH_ACCOUNT,
      Constants.FETCH_ACCOUNT_RESPONSE
    );
  }

  static logout() {

    ApiActions.delete(
      '/v1/logout',
      undefined,
      Store,
      Constants.LOGOUT,
      Constants.LOGOUT_RESPONSE
    );
  }

  static resetStore() {

    Store.dispatch({ type: Constants.RESET_STORE });
  }

  static fetchAlerts() {
    ApiActions.get(
      '/v1/platform/alerts',
      { platform: 'portal' },
      Store,
      Constants.FETCH_ALERTS,
      Constants.FETCH_ALERTS_RESPONSE
    );
  }

  static hidePlatformAlert() {

    Store.dispatch({
      type: Constants.HIDE_PLATFORM_ALERT,
    });
  }
}


export default Actions;



// WEBPACK FOOTER //
// ./client/pages/main/actions.js